import { render, staticRenderFns } from "./FormTransfer.vue?vue&type=template&id=45dc437b&"
import script from "./FormTransfer.vue?vue&type=script&lang=js&"
export * from "./FormTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports